import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const InstrumentsSold = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default InstrumentsSold;